import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FolderD4signSelect from '../../../../../../containers/integrations/FolderD4signSelect'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import SafeD4signSelect from '../../../../../../containers/integrations/SafeD4signSelect'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import TemplateSelect from '../../../../../../containers/templates/select/TemplateSelect'
import Text from '../../../../../../packages/kiti/components/presentation/Text'
import Textarea from '../../../../../../components/form/Textarea'

const GenPDFAndSendToSignSentence = () => {
  const [open, setOpen] = React.useState()
  const { t } = useTranslation('triggers')
  const { handleChangeIn, form } = useFormState()

  return (
    <>
      <Text size="h2">para os </Text>

      <EditableSentence label={t('d4sign.signers')} truncate={20} onClick={() => setOpen(true)} field="payload" />

      {/* select to create safes and select a safes */}

      <Modal open={open} onClose={() => setOpen(false)} width="32rem">
        <Col width="100%">
          <FormItem label={t('d4sign.signersRequired')} path={['payload', 'signers']} Input={Textarea} />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem label={t('d4sign.documentName')} path={['payload', 'file_name']} />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem
            label={t('d4sign.safe')}
            path={['payload', 'safe']}
            Input={SafeD4signSelect}
            filter={{ integrationId: form.integrationId }}
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem
            label={t('d4sign.folderOptional')}
            path={['payload', 'folder']}
            Input={FolderD4signSelect}
            filter={{ integrationId: form.integrationId, safeId: form.payload?.safe?.id }}
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem
            label={t('d4sign.document')}
            path={['payload', 'template']}
            Input={TemplateSelect}
            filter={{ types: ['dynamic_pdf'] }}
          />
        </Col>

        <Separator weight={4} />

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default GenPDFAndSendToSignSentence
